/* eslint-disable import/no-anonymous-default-export */
import GroupIcon from '@mui/icons-material/Group';
import { useCreatePath } from 'ra-core';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';

import { ListFilterSidebar } from '@/components/filters/ListFilterSidebar';

export const UserListFilter = () => {
    const createPath = useCreatePath();
    const stopPropagation = (e: any) => e.stopPropagation();

    return (
        <ListFilterSidebar searchPlaceholder="Search name, email, etc.">
            <Button
                component={Link}
                to={createPath({ resource: 'roles', type: 'list' })}
                label={'Go Roles'}
                onClick={stopPropagation}
                sx={{ mt: 1 }}
            >
                <GroupIcon />
            </Button>
        </ListFilterSidebar>
    );
};
